<div class="ticket-term-pick" uppDataid="terminal-pick">
    <upp-dialog-header>
        <ion-header>
            <ion-toolbar color="primary">
                <ion-title slot="start" uppDataid="terminal-pick-title">
                    {{tr('@ticket_term_pick_title')}}
                </ion-title>
            </ion-toolbar>
        </ion-header>
    </upp-dialog-header>

    <upp-dialog-content>
        <ion-list lines="full" class="ticket-term-pick__list">
            <ion-item
                *ngFor="let option of options; trackBy: OptionTrack"
                button
                detail="false"
                [class.ticket-term-pick__item--selected]="IsSelected(option)"
                [uppDataid]="'terminal-pick-option-' + (option.terminal.name || option.terminal._uuid)"
                (click)="OnOptionClick(option)">
                <ion-label>
                    <h2>{{option.terminal.name}}</h2>
                    <p>{{TillLabel(option)}}</p>
                </ion-label>
                <ion-badge
                    *ngIf="option.connected"
                    slot="end"
                    color="success"
                    uppDataid="terminal-pick-connected">
                    {{tr('@ticket_term_pick_connected')}}
                </ion-badge>
            </ion-item>
        </ion-list>
    </upp-dialog-content>

    <upp-dialog-footer class="ticket-term-pick__footer">
        <ion-button
            uppDataid="terminal-pick-cancel"
            expand="block"
            fill="clear"
            color="medium"
            (click)="OnCancelClick()">
            {{tr('@ticket_term_pick_cancel')}}
        </ion-button>
    </upp-dialog-footer>
</div>
